module.exports = __webpack_public_path__ + "media/img/referrals/link-1bd7b18c4d6ac6cbeebe51c3533b5b51.png";